import OapBeforeAfter from './code/Scripts/components/OapBeforeAfter.vue';

export default {
  components: {
    OapBeforeAfter,
  },
};
